import React, { memo, ReactElement, ReactNode } from "react";
import {
    Container,
    Block,
    BlockHeader,
    BlockContent,
    BlockSavingsBanner,
    StyledLine,
    StyledCircle,
    Row,
    Col,
    Divider,
} from "./styles";

const Header = memo(function Header(props: { width?: number }) {
    return <BlockHeader width={props.width} />;
});

const SavingsBanner = memo(function SavingsBanner() {
    return <BlockSavingsBanner />;
});

const Line = memo(function Line(props: { fat?: boolean; width?: number; height?: number }) {
    return <StyledLine fat={props.fat} width={props.width} height={props.height} />;
});

const Circle = memo(function Circle(props: { size?: number }) {
    return <StyledCircle size={props.size} />;
});

const RowComponent = memo(function RowComponent(props: { children?: ReactNode }) {
    return <Row>{props.children}</Row>;
});

const ColComponent = memo(function ColComponent(props: { children?: ReactNode }) {
    return <Col>{props.children}</Col>;
});

const Shimmerv4 = (): ReactElement => {
    return (
        <Container>
            <Block>
                <SavingsBanner />
            </Block>

            <Block>
                <Header />
                <BlockContent>
                    <RowComponent>
                        <Line fat width={60} />
                        <Line fat width={20} />
                    </RowComponent>
                    <RowComponent>
                        <Line fat width={40} />
                        <Line fat width={20} />
                    </RowComponent>

                    <Divider />

                    <RowComponent>
                        <Line fat width={80} />
                        <Circle />
                    </RowComponent>
                </BlockContent>
            </Block>

            <Block>
                <Header width={45} />
                <BlockContent>
                    <ColComponent>
                        <Line fat width={40} />
                        <Line width={60} />
                    </ColComponent>
                </BlockContent>
                <BlockContent>
                    <ColComponent>
                        <Line fat width={40} />
                        <Line width={75} />
                        <Line width={75} />
                    </ColComponent>
                </BlockContent>
            </Block>

            <Block>
                <Header width={55} />
                <BlockContent>
                    <ColComponent>
                        <Line fat width={40} />
                        <Line width={75} />
                        <Line width={75} />
                    </ColComponent>
                </BlockContent>
            </Block>

            <Block className="fixed-bottom">
                <BlockContent className="footer-bottom">
                    <RowComponent>
                        <ColComponent>
                            <Line fat width={40} />
                            <Line width={65} />
                        </ColComponent>

                        <ColComponent>
                            <Line fat width={100} height={44} />
                        </ColComponent>
                    </RowComponent>
                </BlockContent>
            </Block>
        </Container>
    );
};

export default Shimmerv4;
